import React, {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {useHistory, useLocation} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import PrivateRoute from '../../routes/PrivateRoute'
import GeneracionComprobanteRetencion from './GeneracionComprobanteRetencion.page'
import ResumenFacturaComprobanteRetencion from './ResumenFacturaComprobanteRetencion.page'
import {actionComprobanteRetencionCliente, actionComprobanteRetencionEmision} from '../../actions/action-creators'
import { docsDatosReceptorReset, setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import { State } from '../../reducers'
import ModalSalir from '../../components/Modals/Generales/ModalConfirmSalir'

const ComprobanteRetencionIndex = () => {
  const datosFacturaRes = useSelector((state:State) => state.comprobanteRetencion.datosFacturaRes)
  const {sucursalesCargadas, catalogoSucursal} = useSelector((state:State) => state.comprobanteRetencion)
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const {comprobanteRetencionConsultarCatalogos} = bindActionCreators(actionComprobanteRetencionCliente, dispatch)
  const {comprobanteRetencionClearAll} = bindActionCreators(actionComprobanteRetencionEmision, dispatch)

  useEffect(() => {
    if(datosFacturaRes?.JsonFactura) history.push("/otros-documentos/comprobante-retencion/resumen")
    comprobanteRetencionConsultarCatalogos()
    window.scroll(0, 0)
    dispatch(setActiveModuleDoc({idDoc: '7', title: 'Comprobante Retención'}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let url = location.pathname.toLowerCase()
    if (url.includes('/otros-documentos/comprobante-retencion/')) {if (url === '/otros-documentos/comprobante-retencion/formulario' || url === '/otros-documentos/comprobante-retencion/resumen') return
    }
    history.push('/404')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <BasicLayout>
      <ModalSalir
        excludeValidate={sucursalesCargadas && (!catalogoSucursal || catalogoSucursal.length === 0)} 
        title='Salir de comprobante de retención' 
        onConfirmExit={() => {comprobanteRetencionClearAll(true); dispatch(docsDatosReceptorReset())}} 
        includeText='/comprobante-retencion/' 
      />
      <PrivateRoute exact path='/otros-documentos/comprobante-retencion/formulario' component={GeneracionComprobanteRetencion}/>
      <PrivateRoute exact path='/otros-documentos/comprobante-retencion/resumen' component={ResumenFacturaComprobanteRetencion} />
    </BasicLayout>
  )
}

export default ComprobanteRetencionIndex
